// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__Bhejl","productName":"Table_productName__1wddo"};